$(document).ready(function(){
    let body = $('body');
    let searchButton = $('.eq-header__icon-search .eq-header__icon-link');
    let searchInput = $('.eq-header__icon-search .eq-search-data__form-input input.eq-search-data__input');
    let searchForm = $('.eq-header__icon-search .eq-search-data__form');
    let searchRemove = $('.eq-header__icon-search .eq-search-data__form-input .eq-search-data__remove');

    $(searchButton).on('click', function(e){
        e.preventDefault();
        
        let searchParent = $(this).parent();

        if (searchParent.hasClass('eq-header__icon-search')) {

            if (searchParent.hasClass('eq-search-open')) {
                searchParent.removeClass('eq-search-open');
            } else {
                searchParent.addClass('eq-search-open');
            }
        }
    });

    $(searchInput).on('input.eq-search-data__input', function(){
        if($(this).val().length > 0){
            searchRemove.addClass('has-content');
            searchForm.addClass('search-data-visible');
        } else {
            searchRemove.removeClass('has-content');
            searchForm.removeClass('search-data-visible');
        }
    });

    if(searchInput.length > 0 &&  searchInput.val().length > 0){
        searchRemove.addClass('has-content');
        searchForm.addClass('search-data-visible');
    }

    $(searchRemove).on('click', function(){
        console.log("Click Remove Form Class", $(searchForm).attr('class'));
        console.log("Click Remove Button", $(this).attr('class'));

        
        if ($(searchForm).hasClass('search-data-visible') && $(this).hasClass('has-content')) {
            console.log("Remove IF");
            $(searchForm).removeClass('search-data-visible');
            $(this).removeClass('has-content');
        } else {
            console.log("Remove ELSE");
        }
    });

    $(".eq-search-data--desktop predictive-search .reset__button").on('click', function(){
        let searchData = $(".eq-search-data--desktop predictive-search form .search-input").val();
        if (searchData != "") {
            $(".eq-search-data--desktop .predictive-search-result").css("display", "none");
            $(".eq-search-data--desktop predictive-search form .search-input").val("");
            $(this).hide();
        }
    });

    $(".eq-search-data--desktop predictive-search form .search-input").on("keyup", function () {
        if ($(".eq-search-data--desktop predictive-search form .search-input").val().trim() !== "") {
          $(".eq-search-data--desktop predictive-search .reset__button").show();
        } else {
          $(".eq-search-data--desktop predictive-search .reset__button").hide();
        }
    });

    let getSearchDataOnLoad = $('.eq-search-data--desktop predictive-search form .search-input').val();
    if (getSearchDataOnLoad && getSearchDataOnLoad.trim() !== '') {
        $(".eq-search-data--desktop predictive-search .reset__button").show();
    }else {
        $(".eq-search-data--desktop predictive-search .reset__button").hide();
    }


    $(".eq-search-data--mobile predictive-search .reset__button").on('click', function(){
        let searchData = $(".eq-search-data--mobile predictive-search form .search-input").val();
        if (searchData != "") {
            $(".eq-search-data--mobile .predictive-search-result").css("display", "none");
            $(".eq-search-data--mobile predictive-search form .search-input").val("");
            $(this).hide();
        }
    });

    $(".eq-search-data--mobile predictive-search form .search-input").on("keyup", function () {
        if ($(".eq-search-data--mobile predictive-search form .search-input").val().trim() !== "") {
          $(".eq-search-data--mobile predictive-search .reset__button").show();
        } else {
          $(".eq-search-data--mobile predictive-search .reset__button").hide();
        }
    });

    let getSearchDataOnLoadMob = $('.eq-search-data--desktop predictive-search form .search-input').val();

    if (getSearchDataOnLoadMob && getSearchDataOnLoadMob.trim() !== '') {
        $(".eq-search-data--mobile predictive-search .reset__button").show();
    }else {
        $(".eq-search-data--mobile predictive-search .reset__button").hide();
    }
    

    $(document).on('click', function(e) {
        let container = $(".eq-header__icon-link, .eq-search-data__wrap");

        if (!$(container).is(e.target) && $(container).has(e.target).length === 0) 
        {
            $(".eq-header__icon-search").removeClass("eq-search-open");
        }
    });

    $(document).on('click', function(e) {
        let container = $(".blog-search-complete, .eq-blog-list__search input, .eq-blog-list__search svg");

        if (!$(container).is(e.target) && $(container).has(e.target).length === 0) 
        {
            $(".blog-search-complete").hide();
            $(".eq-blog-list__search input").val("");
            $(".eq-blog-list__search .search-block .remove").removeClass("active");
        }
    });

    let hamburgerButton = $('.eq-header__btn-hamburger');
    let closeButton = $('.eq-header__btn-menuclose');
    let menu = $('.eq-header__menu');
    let menuWrapper = $('.eq-header__wrapper');

    function updateMenuHeight() {
        let headerHeight = $('.eq-header').outerHeight();
        let announcementBarHeight = 0;
        // let announcementBarHeight = $('.eq-announcement-bar').outerHeight();
        // let totalHeight = headerHeight + announcementBarHeight;

        if ($('.eq-announcement-bar').length > 0 && $('.eq-announcement-bar').is(':visible')) {
            announcementBarHeight = $('.eq-announcement-bar').outerHeight();
        }

        let totalHeight = headerHeight + announcementBarHeight;        
        
        menu.css({
            'height': 'calc(100dvh - ' + totalHeight + 'px)',
            'top': totalHeight + 'px'
        });
    }

    if ($(window).width() <= 991) {

        function openMenu() {
            menuWrapper.addClass('is-menu-open');
            body.addClass('hide-overflow')
            body.addClass('is-menu-open');
            updateMenuHeight();
        }
        
        function closeMenu() {
            menuWrapper.removeClass('is-menu-open');
            body.removeClass('hide-overflow')
            body.removeClass('is-menu-open');

            menu.css({
                'height': '100dvh',
                'top': '-100%'
            });
        }

        hamburgerButton.on('click', openMenu);
        closeButton.on('click', closeMenu);

        $('.eq-header__nav-link').on('click', function(e) {
            let parentItem = $(this).closest('.eq-header__nav-item');
            let submenu = parentItem.find('.eq-header__nav-dropdown');
    
            $('.eq-header__nav-item').not(parentItem).each(function() {
                let otherSubmenu = $(this).find('.eq-header__nav-dropdown');
                if (otherSubmenu.is(':visible')) {
                    otherSubmenu.slideUp(300);
                    $(this).removeClass('is-submenu-open');
                }
            });
    
            if (submenu.length) {
                e.preventDefault();
    
                if (parentItem.hasClass('is-submenu-open')) {
                    submenu.slideUp(300);
                    parentItem.removeClass('is-submenu-open');
                } else {
                    submenu.slideDown(300);
                    parentItem.addClass('is-submenu-open');
                }
            }
        });

        $(window).on('resize', function() {
            updateMenuHeight();
        });

    }


    // Function to initialize slick slider
    function initializeSlick(element) {
        let wrap = $(element).find('.product-tab-detail__wrap');
        
        if ($(element).hasClass('tab-slider-view')) {
            if (!wrap.hasClass('slick-initialized')) {
                wrap.slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }
                    ]
                });
            }
        }
    }

    function resizeSlick(element) {
        let wrap = $(element).find('.product-tab-detail__wrap');
        if (wrap.hasClass('slick-initialized')) {
            wrap.slick('setPosition');            
        }
    }


    $('.product-tab-detail__heading').on('click', function(e) {
        let parentItem = $(this).closest('.product-tab-detail');
        let wrap = parentItem.find('.product-tab-detail__wrap');
        
        $('.product-tab-detail').not(parentItem).each(function() {
            let otherWrap = $(this).find('.product-tab-detail__wrap');
            if (otherWrap.is(':visible')) {
                // otherWrap.slideUp(300);
                otherWrap.addClass('hidden-slider').slideUp(300, function() {
                    // Optionally, reset visibility here if needed
                });
                $(this).removeClass('is-dropdown-open');
            }
        });

        if (wrap.length) {
            e.preventDefault();

            if (parentItem.hasClass('is-dropdown-open')) {
                wrap.slideUp(300, function() {
                    if ($(window).width() <= 767) {
                        wrap.addClass('hidden-slider');
                    }
                });
                parentItem.removeClass('is-dropdown-open');
            } else {
                wrap.slideDown(300, function() {
                    if ($('.eq-product-tab__tab-detail').hasClass('tab-slider-view')) {
                        console.log("Has tab-slider-view");
                        if ($(window).width() <= 767) {
                            console.log("check hidden class");
                            wrap.removeClass('hidden-slider'); 
                        }
                        initializeSlick(parentItem);
                        resizeSlick(parentItem);
                        
                    }                
                });
                parentItem.addClass('is-dropdown-open');
            }
        }
    });

    function initialize() {
        let windowWidth = $(window).width();

        $('.eq-product-tab__tab-detail').each(function() {
            let tabDetail = $(this);
            let wrap = tabDetail.find('.product-tab-detail__wrap');

            if (tabDetail.hasClass('tab-grid-view')) {

                if (wrap.hasClass('slick-initialized')) {
                    wrap.slick('unslick');
                }
            } else if (tabDetail.hasClass('tab-slider-view')) {
                if (windowWidth <= 767) {
                    wrap.addClass('hidden-slider');
                }
                initializeSlick(tabDetail);
            }
        });

        if (windowWidth > 767) {
            $('.eq-product-tab__tab-item:first-child').addClass('active');
            $('.eq-product-tab__tab-detail .product-tab-detail').first().addClass('active');
        } else {
            $('.product-tab-detail__wrap').slideUp(0);
            $('.product-tab-detail').removeClass('is-dropdown-open');
        }
    }

    initialize();

    $('.js-product-tab-button').on('click', function(e) {
        e.preventDefault();
        console.log("Click");
        
        let tabButton = $(this);
        console.log('TabButton : ', tabButton);

        let targetTab = tabButton.attr('data-city');
        console.log('TargetTab : ', targetTab);
        
        tabButton.parent().addClass('active');
        tabButton.parent().siblings().removeClass('active');

        $('.eq-product-tab__tab-detail .product-tab-detail').each(function() {
            console.log("Each Loop ", $(this));
            if ($(this).attr('id') === targetTab) {
                console.log("Detail Tab Match");
                $(this).addClass('active');
                $(this).siblings().removeClass('active');
                if ($('.eq-product-tab__tab-detail').hasClass('tab-slider-view')) {
                    resizeSlick($(this));
                }
            } else {
                $(this).removeClass('active');
            }
        });
    });

    let ProductReviewSlider = $('.js-product-review-slider');

    let slidesToShowDesktop = ProductReviewSlider.attr('data-slide-desktop') && ProductReviewSlider.attr('data-slide-desktop') !== "" && ProductReviewSlider.attr('data-slide-desktop') !== undefined && ProductReviewSlider.attr('data-slide-desktop') !== null ?
    parseInt(ProductReviewSlider.attr('data-slide-desktop')) : 3;

    let slidesToShowTablet = ProductReviewSlider.attr('data-slide-tablet') && ProductReviewSlider.attr('data-slide-tablet') !== "" && ProductReviewSlider.attr('data-slide-tablet') !== undefined && ProductReviewSlider.attr('data-slide-tablet') !== null ?
    parseInt(ProductReviewSlider.attr('data-slide-tablet')) : 2;

    let slidesToShowMobile = ProductReviewSlider.attr('data-slide-mobile') && ProductReviewSlider.attr('data-slide-mobile') !== "" && ProductReviewSlider.attr('data-slide-mobile') !== undefined && ProductReviewSlider.attr('data-slide-mobile') !== null ?
    parseInt(ProductReviewSlider.attr('data-slide-mobile')) : 1;

    if(ProductReviewSlider.length > 0 && ProductReviewSlider.find('.eq-product-review__slide').length > 0 ){
        ProductReviewSlider.slick({
            slidesToShow: slidesToShowDesktop,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: false,
            variableWidth: false,
            prevArrow: '<button type="button" aria-label="Previous" class="prev-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="left-arrow"><polygon points="95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46"></polygon></g></svg></button>',
            nextArrow: '<button type="button" aria-label="Next" class="next-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="right-arrow"><polygon points="57.09 16.78 51.82 22.8 78.32 46 4.96 46 4.96 54 78.32 54 51.82 77.2 57.09 83.22 95.04 50 57.09 16.78"></polygon></g></svg></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: slidesToShowTablet,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: slidesToShowMobile,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    let reviewSliderTitle = $('.eq-product-review__slide .eq-product-review__detail .eq-product-review__block-title');

    if(reviewSliderTitle.length > 0){
        reviewSliderTitle.matchHeight({ 
            byRow: true,
        });
    }

    let reviewSliderInformation = $('.eq-product-review__slide .eq-product-review__detail .eq-product-review__rte');

    if(reviewSliderInformation.length > 0){
        reviewSliderInformation.matchHeight({ 
            byRow: true,
        });
    }


    let sellProduct = $('.js-our-sellers');

    if(sellProduct.length > 0 && sellProduct.find('.eq-our-sellers__slide').length > 0 ){
        sellProduct.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: false,
            variableWidth: false,
            loop: false,
            infinite: false,
            autoplay: false,
            prevArrow: '<button type="button" aria-label="Previous" class="prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" /></svg></button>',
            nextArrow: '<button type="button" aria-label="Next" class="next-arrow"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6"><path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" /></svg></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1.15,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }


    let articleListSlider = $('.js-article-list-slider');

    let articleSlidesToShowDesktop = articleListSlider.attr('data-slide-desktop') && articleListSlider.attr('data-slide-desktop') !== "" && articleListSlider.attr('data-slide-desktop') !== undefined && articleListSlider.attr('data-slide-desktop') !== null ?
    parseInt(articleListSlider.attr('data-slide-desktop')) : 3;

    let articleSlidesToShowTablet = articleListSlider.attr('data-slide-tablet') && articleListSlider.attr('data-slide-tablet') !== "" && articleListSlider.attr('data-slide-tablet') !== undefined && articleListSlider.attr('data-slide-tablet') !== null ?
    parseInt(articleListSlider.attr('data-slide-tablet')) : 2;

    let articleSlidesToShowMobile = articleListSlider.attr('data-slide-mobile') && articleListSlider.attr('data-slide-mobile') !== "" && articleListSlider.attr('data-slide-mobile') !== undefined && articleListSlider.attr('data-slide-mobile') !== null ?
    parseInt(articleListSlider.attr('data-slide-mobile')) : 1;

    if(articleListSlider.length > 0 && articleListSlider.find('.eq-article-list__slide').length > 0 ){
        articleListSlider.slick({
            slidesToShow: articleSlidesToShowDesktop,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: false,
            variableWidth: false,
            prevArrow: '<button type="button" aria-label="Previous" class="prev-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="left-arrow"><polygon points="95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46"></polygon></g></svg></button>',
            nextArrow: '<button type="button" aria-label="Next" class="next-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="right-arrow"><polygon points="57.09 16.78 51.82 22.8 78.32 46 4.96 46 4.96 54 78.32 54 51.82 77.2 57.09 83.22 95.04 50 57.09 16.78"></polygon></g></svg></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: articleSlidesToShowTablet,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: articleSlidesToShowMobile,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    let articleSliderInformation = $('.eq-article-list .eq-article-list__block-title');

    if(articleSliderInformation.length > 0){
        articleSliderInformation.matchHeight({ 
            byRow: true,
        });
    }

    let testimonialSliderL1 = $('.js-testimonials-slider-l1');

    if(testimonialSliderL1.length > 0 && testimonialSliderL1.find('.eq-testimonials-l1__slide').length > 0 ){
        testimonialSliderL1.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: false,
            variableWidth: false,
            adaptiveHeight: true,
            autoplay: true,
            autoplaySpeed: 6000,
            prevArrow: '<button type="button" aria-label="Previous" class="prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="4" stroke="currentColor" class="size-6"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" /></svg></button>',
            nextArrow: '<button type="button" aria-label="Next" class="next-arrow"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="4" stroke="currentColor" class="size-6"><path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" /></svg></button>',
        });
    }   

    // quantity plus/minus
    $(document).on("click", ".js-btn-quantity", function (e) {
        e.preventDefault();
        let parent = $(this).closest('.quantity-main');
        let value = parseInt(parent.find('.quantity-input').val()) || 0;
        if ($(this).hasClass('quantity-plus')) {
            value++;
        } else if ($(this).hasClass('quantity-minus')) {
            if (value > 1) {
                value--;
            }
        }
        parent.find('.quantity-input').val(value);
    });
    // end quantity plus/minus

    let PdpSliderProductFor = $('.js-pdp-slider-for');
    let PdpSliderProductNav = $('.js-pdp-slider-nav');

    if(PdpSliderProductFor.length > 0 && PdpSliderProductFor.find('.slider-for__item').length > 0 ){
        PdpSliderProductFor.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '.js-pdp-slider-nav'
        });
        PdpSliderProductNav.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.js-pdp-slider-for',
            dots: false,
            focusOnSelect: true,
            prevArrow: '<button type="button" aria-label="Previous" class="prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0265/5164/8355/files/Group_15_1.svg?v=1719220100" alt="icon" /></button>',
            nextArrow: '<button type="button" aria-label="Next" class="next-arrow"><img src="https://cdn.shopify.com/s/files/1/0265/5164/8355/files/Group_1000001401_1.svg?v=1719220072" alt="icon" /></button>',
        });
    }

    $('.eq-pdp-tab__list li a').on('click', function (e) {
        e.preventDefault();
    
        let targetId = $(this).attr('data-id');        
        $('.eq-pdp-tab__list li').removeClass('tab-active');
        $(this).parent().addClass('tab-active');
    
        if (targetId) {
            $("#" + targetId).fadeIn('slow').siblings(".eq-pdp-tab__content-list").hide();
        } else {
            let href = $(this).attr('href'); 
            if (href && href !== '#') {
                let $target = $(href);
                if ($target.length) {
                    $('html, body').animate({
                        scrollTop: $target.offset().top
                    }, 800);
                }
            }
        }
    });
    
    /*
        $('.eq-faq .accordion > li:first-child').addClass('active');
        $('.eq-faq .accordion > li.active .ans').slideDown();

        $('.eq-faq .accordion h6').on("click", function() {
            let dropDown = $(this).closest('li').find('.ans');

            $(this).closest('.accordion').find('.ans').not(dropDown).slideUp();

            if ($(this).parent("li").hasClass('active')) {
                $(this).parent("li").removeClass('active');
            } else {
                $(this).closest('.accordion').find('li.active').removeClass('active');
                $(this).parent("li").addClass('active');
            }

            dropDown.stop(false, true).slideToggle();

        });
    */


    // if($('.eq-joy-customers__slider-item .product-card .product-card__title').length > 0){
    //     $('.eq-joy-customers__slider-item .product-card .product-card__title').matchHeight({
    //         byRow: 0,
    //     });
    // }


    if($('.product-card .product-card__badeges .product-card__badege-media').length > 0){
        $('.product-card .product-card__badeges .product-card__badege-media').matchHeight({
            byRow: true,
        });
    }

    let middleBadeges = $('.product-card .product-card__badeges-middle');
    if(middleBadeges.length > 0){
        middleBadeges.matchHeight({ 
            byRow: true,
        });
    }

    if($('.product-card .product-card__title').length > 0){
        $('.product-card .product-card__title').matchHeight({
            byRow: true,
        });
    }

    if($('.eq-cbd-best-sellers__box-content .desc').length > 0){
        $('.eq-cbd-best-sellers__box-content .desc').matchHeight({
            byRow: true,
        });
    }
    
    let collectionDetailBlock = $('.eq-collection-header__information');
    let collectionDetail = $('.eq-collection-header__information p');
    let collectionDetailShowHideBtn = $('.eq-collection-header__toggle-detail');
    
    function truncateText(contentElement) {
        let content = contentElement.text();
        let wordCount = content.split(' ').length;
        if (wordCount > 50) {
            var truncatedText = content.split(' ').slice(0, 40).join(' ') + '...';
            contentElement.data('full-text', content);
            contentElement.text(truncatedText);
            return true;
        } else {
            contentElement.data('full-text', content);
            return false;
        }
    }

    if(collectionDetailBlock.length > 0 && collectionDetailBlock.hasClass('is-truncate-detail') && collectionDetailShowHideBtn.length > 0){
        if (truncateText(collectionDetail)) {
            collectionDetailShowHideBtn.show();
        }
    
        $(document).on('click', collectionDetailShowHideBtn , function(e) { 
            e.preventDefault();
            console.log("click");
            var fullText = collectionDetail.data('full-text');
            
            if (collectionDetail.text().indexOf('...') !== -1) {
                collectionDetail.text(fullText);
                collectionDetailShowHideBtn.text('Read Less');
            } else {
                var truncatedText = fullText.split(' ').slice(0, 40).join(' ') + '...';
                collectionDetail.text(truncatedText);
                collectionDetailShowHideBtn.text('Read More');
            }
        });
    }


    let testimonialSliderL2 = $('.js-testimonials-slider-l2');

    if(testimonialSliderL2.length > 0 && testimonialSliderL2.find('.eq-testimonials-l2__slide').length > 0 ){
        testimonialSliderL2.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: false,
            autoplay: false,
            infinite: false,
            variableWidth: true,
            loop: false,
            prevArrow: '.prev-arrow',
            nextArrow: '.next-arrow',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        variableWidth: false,
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        // Handle the disabling of custom arrows based on Slick's `slick-disabled` class
        testimonialSliderL2.on('afterChange', function(event, slick, currentSlide) {
            updateArrowState(slick);
        });

        // Update arrow state (enabled/disabled) on initialization and after each change
        function updateArrowState(slick) {
            if(slick.slickCurrentSlide() === 0) {
                $('.prev-arrow').addClass('slick-disabled');
            } else {
                $('.prev-arrow').removeClass('slick-disabled');
            }
    
            if(slick.slickCurrentSlide() === slick.slideCount - 1) {
                $('.next-arrow').addClass('slick-disabled');
            } else {
                $('.next-arrow').removeClass('slick-disabled');
            }
        }

        // Initial arrow state check
        updateArrowState(testimonialSliderL2.slick('getSlick'));
    }

    /*
    let testimonialSliderL3 = $('.js-testimonials-slider-l3');

    if(testimonialSliderL3.length > 0 && testimonialSliderL3.find('.eq-testimonials-l3__slide').length > 0 ){
        testimonialSliderL3.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: false,
            variableWidth: false,
            adaptiveHeight: true,
            autoplay: true,
            autoplaySpeed: 6000,
            prevArrow: '<button type="button" aria-label="Previous" class="prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="left-arrow"><polygon points="95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46"></polygon></g></svg></button>',
            nextArrow: '<button type="button" aria-label="Next" class="next-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="right-arrow"><polygon points="57.09 16.78 51.82 22.8 78.32 46 4.96 46 4.96 54 78.32 54 51.82 77.2 57.09 83.22 95.04 50 57.09 16.78"></polygon></g></svg></button>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    }
    */

    if($('.eq-testimonials-l3__information h6').length > 0){
        $('.eq-testimonials-l3__information h6').matchHeight({
            byRow: 1,
        });
    }
    if($('.eq-testimonials-l3__information p').length > 0){
        $('.eq-testimonials-l3__information p').matchHeight({
            byRow: 1,
        });
    }
    if($('.eq-process-step__block .eq-process-step__block-title').length > 0){
        $('.eq-process-step__block .eq-process-step__block-title').matchHeight({
            byRow: 1,
        });
    }

    if ($('.eq-accordion__box').length > 0) {
        $('.eq-accordion__box').each(function() {
            if($(this).hasClass('eq-accordion__no-accordion')){
                console.log("Do Not want accordion ");
            } else if ($(this).find('.eq-accordion__row').hasClass('is-accordion-open') && $(this).find('.eq-accordion__col').length > 0) {
                
                $(this).find('.eq-accordion__col').each(function() {
                    if( $(this).find('.eq-accordion__block').length > 0 && $(this).find('.eq-accordion__answer').length > 0){
                        if (!$(this).find('.eq-accordion__block').hasClass('is-active-accordion')) {
                            $(this).find('.eq-accordion__block').addClass('is-active-accordion');
                        }
                        if (!$(this).find('.eq-accordion__answer').hasClass('is-open-detail')) {
                            $(this).find('.eq-accordion__answer').addClass('is-open-detail').slideDown(350);
                        }
                    }
                });
            }
        });
    }

    if ($('.eq-accordion__question').length > 0) {
        $('.eq-accordion__box').each(function() {
            let currentBox = $(this);

            if (!currentBox.is('.eq-accordion__no-accordion')) {
                currentBox.find('.eq-accordion__question').on('click', function() {
                    let accordionBlock = $(this).closest('.eq-accordion__block');
                    let accordionAnswer = accordionBlock.find('.eq-accordion__answer');
    
                    /*
                    currentBox.find('.eq-accordion__block').not(accordionBlock).removeClass('is-active-accordion');
                    currentBox.find('.eq-accordion__answer').not(accordionAnswer).removeClass('is-open-detail');
                    */
    
                    if (!accordionBlock.hasClass('is-active-accordion')) {
                        accordionBlock.addClass('is-active-accordion');
                        accordionAnswer.addClass('is-open-detail').slideDown(350);
                    } else {
                        accordionBlock.removeClass('is-active-accordion');
                        accordionAnswer.removeClass('is-open-detail').slideUp(350);
                    }
                });
            }
        });
    }



    let collectionProductSlider = $('.js-collection-product-slider');

    let collectionSlidesToShowDesktop = collectionProductSlider.attr('data-slide-desktop') && collectionProductSlider.attr('data-slide-desktop') !== "" && collectionProductSlider.attr('data-slide-desktop') !== undefined && collectionProductSlider.attr('data-slide-desktop') !== null ?
    parseInt(collectionProductSlider.attr('data-slide-desktop')) : 3;

    let collectionSlidesToShowTablet = collectionProductSlider.attr('data-slide-tablet') && collectionProductSlider.attr('data-slide-tablet') !== "" && collectionProductSlider.attr('data-slide-tablet') !== undefined && collectionProductSlider.attr('data-slide-tablet') !== null ?
    parseInt(collectionProductSlider.attr('data-slide-tablet')) : 2;

    let collectionSlidesToShowMobile = collectionProductSlider.attr('data-slide-mobile') && collectionProductSlider.attr('data-slide-mobile') !== "" && collectionProductSlider.attr('data-slide-mobile') !== undefined && collectionProductSlider.attr('data-slide-mobile') !== null ?
    parseInt(collectionProductSlider.attr('data-slide-mobile')) : 1;

    if(collectionProductSlider.length > 0 && collectionProductSlider.find('.eq-collection-product__block').length > 0 ){
        collectionProductSlider.slick({
            slidesToShow: collectionSlidesToShowDesktop,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: false,
            variableWidth: false,
            prevArrow: '<button type="button" aria-label="Previous" class="prev-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="left-arrow"><polygon points="95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46"></polygon></g></svg></button>',
            nextArrow: '<button type="button" aria-label="Next" class="next-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="right-arrow"><polygon points="57.09 16.78 51.82 22.8 78.32 46 4.96 46 4.96 54 78.32 54 51.82 77.2 57.09 83.22 95.04 50 57.09 16.78"></polygon></g></svg></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: collectionSlidesToShowTablet,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: collectionSlidesToShowMobile,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    } 

    let collectionProductSliderl1 = $('.js-collection-product-l1-slider');

    let collectionSlidesToShowDesktop1 = collectionProductSliderl1.attr('data-slide-desktop') && collectionProductSliderl1.attr('data-slide-desktop') !== "" && collectionProductSliderl1.attr('data-slide-desktop') !== undefined && collectionProductSliderl1.attr('data-slide-desktop') !== null ?
    parseInt(collectionProductSliderl1.attr('data-slide-desktop')) : 3;

    let collectionSlidesToShowTablet1 = collectionProductSliderl1.attr('data-slide-tablet') && collectionProductSliderl1.attr('data-slide-tablet') !== "" && collectionProductSliderl1.attr('data-slide-tablet') !== undefined && collectionProductSliderl1.attr('data-slide-tablet') !== null ?
    parseInt(collectionProductSliderl1.attr('data-slide-tablet')) : 2;

    let collectionSlidesToShowMobile1 = collectionProductSliderl1.attr('data-slide-mobile') && collectionProductSliderl1.attr('data-slide-mobile') !== "" && collectionProductSliderl1.attr('data-slide-mobile') !== undefined && collectionProductSliderl1.attr('data-slide-mobile') !== null ?
    parseInt(collectionProductSliderl1.attr('data-slide-mobile')) : 1;

    if(collectionProductSliderl1.length > 0 && collectionProductSliderl1.find('.eq-collection-product-l1__block').length > 0 ){
        collectionProductSliderl1.slick({
            slidesToShow: collectionSlidesToShowDesktop1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: false,
            variableWidth: false,
            prevArrow: '<button type="button" aria-label="Previous" class="prev-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="left-arrow"><polygon points="95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46"></polygon></g></svg></button>',
            nextArrow: '<button type="button" aria-label="Next" class="next-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="right-arrow"><polygon points="57.09 16.78 51.82 22.8 78.32 46 4.96 46 4.96 54 78.32 54 51.82 77.2 57.09 83.22 95.04 50 57.09 16.78"></polygon></g></svg></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: collectionSlidesToShowTablet1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: collectionSlidesToShowMobile1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }


    let featuredCollectionProductSlider = $('.js-featured-collection-product-slider');

    let featuredCollectionSlidesToShowDesktop = featuredCollectionProductSlider.attr('data-slide-desktop') && featuredCollectionProductSlider.attr('data-slide-desktop') !== "" && featuredCollectionProductSlider.attr('data-slide-desktop') !== undefined && featuredCollectionProductSlider.attr('data-slide-desktop') !== null ?
    parseInt(featuredCollectionProductSlider.attr('data-slide-desktop')) : 3;

    let featuredCollectionSlidesToShowTablet = featuredCollectionProductSlider.attr('data-slide-tablet') && featuredCollectionProductSlider.attr('data-slide-tablet') !== "" && featuredCollectionProductSlider.attr('data-slide-tablet') !== undefined && featuredCollectionProductSlider.attr('data-slide-tablet') !== null ?
    parseInt(featuredCollectionProductSlider.attr('data-slide-tablet')) : 2;

    let featuredCollectionSlidesToShowMobile = featuredCollectionProductSlider.attr('data-slide-mobile') && featuredCollectionProductSlider.attr('data-slide-mobile') !== "" && featuredCollectionProductSlider.attr('data-slide-mobile') !== undefined && featuredCollectionProductSlider.attr('data-slide-mobile') !== null ?
    parseInt(featuredCollectionProductSlider.attr('data-slide-mobile')) : 1;

    
    if(featuredCollectionProductSlider.length > 0 && featuredCollectionProductSlider.find('.eq-featured-product__block').length > 0 ){
        featuredCollectionProductSlider.slick({
            slidesToShow: featuredCollectionSlidesToShowDesktop,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: false,
            variableWidth: false,
            prevArrow: '<button type="button" aria-label="Previous" class="prev-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="left-arrow"><polygon points="95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46"></polygon></g></svg></button>',
            nextArrow: '<button type="button" aria-label="Next" class="next-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="right-arrow"><polygon points="57.09 16.78 51.82 22.8 78.32 46 4.96 46 4.96 54 78.32 54 51.82 77.2 57.09 83.22 95.04 50 57.09 16.78"></polygon></g></svg></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: featuredCollectionSlidesToShowTablet,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: featuredCollectionSlidesToShowMobile,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    } 

    $('.history-btn, .history-close').on('click', function(e){
        e.preventDefault();
        if($('.history-modal').length > 0){
            $('.history-modal').toggleClass('is-active');
        }
    });
    
    $(document).on('click', '.eq-announcement-bar__close-button ', function(e) {
        e.preventDefault();
        $('.eq-announcement-bar').remove();

        if ($(window).width() <= 991) {
            console.log("For Remove Announcement Bar");
            updateMenuHeight();
        } else {
            handleStickyElements();
        }
    });

    $('.eq-videos-expertise-l1__item[data-fancybox]').fancybox({});

    let testimonialSliderL4 = $('.js-testimonials-slider-l4');
    
    let prevArrowCustom = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.3174 14.9401L6.42738 10.0501C5.84988 9.47256 5.84988 8.52756 6.42738 7.95006L11.3174 3.06006" stroke="#393939" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    let nextArrowCustom = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.68262 14.9401L11.5726 10.0501C12.1501 9.47256 12.1501 8.52756 11.5726 7.95006L6.68262 3.06006" stroke="#393939" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

    if(testimonialSliderL4.length > 0 && testimonialSliderL4.find('.eq-testimonials-l4__slide').length > 0){
        testimonialSliderL4.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            centerMode: false,
            variableWidth: false,
            adaptiveHeight: true,
            autoplay: false,
            autoplaySpeed: 6000,
            prevArrow: `<button type="button" aria-label="Previous" class="prev-arrow">${prevArrowCustom}</button>`,
            nextArrow: `<button type="button" aria-label="Next" class="next-arrow">${nextArrowCustom}</button>`,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    }

    let testimonialSliderL5 = $('.js-testimonials-slider-l5');
    
    let prevArrowCustomL5 = `<img src="https://joyorganics.com/cdn/shop/t/160/assets/arrow-l.png?v=173563952378923971611731911966" alt="prev arrow">`;
    let nextArrowCustomL5 = `<img src="https://joyorganics.com/cdn/shop/t/160/assets/arrow-r.png?v=64802038806612222901731911967" alt="next arrow">`;

    if(testimonialSliderL5.length > 0 && testimonialSliderL5.find('.eq-testimonials-l5__item').length > 0){
        testimonialSliderL5.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: false,
            variableWidth: false,
            adaptiveHeight: false,
            autoplay: false,
            infinite: false,
            autoplaySpeed: 6000,
            prevArrow: `<button type="button" aria-label="Previous" class="prev-arrow">${prevArrowCustomL5}</button>`,
            nextArrow: `<button type="button" aria-label="Next" class="next-arrow">${nextArrowCustomL5}</button>`,
        });
    }

    let sliderUsp = $(".js-pdp-l2-usp-slider");

    if(sliderUsp.length > 0 && sliderUsp.find('.eq-pdp-l2__usp-slider-col').length > 0){
        let sliderUspOption = {
            speed: 5000,
            autoplay: true,
            autoplaySpeed: 0,
            centerMode: false,
            cssEase: "linear",
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            initialSlide: 1,
            arrows: false,
            mobileFirst: !0,
            responsive: [{ breakpoint: 992, settings: "unslick" }],
        };
        let winSliderUsp = $(window);
        winSliderUsp.on("load resize", function () {
            winSliderUsp.width() < 992 ? sliderUsp.not(".slick-initialized").slick(sliderUspOption) : sliderUsp.hasClass("slick-initialized") && sliderUsp.slick("unslick");
        });
    }


    if ($('.eq-accordion-l3__question').length > 0) {
        $('.eq-accordion-l3__box').each(function() {
            let currentBox = $(this);

            currentBox.find(".eq-accordion-l3__col").first().find(".eq-accordion-l3__block").addClass('is-active-accordion');
            currentBox.find(".eq-accordion-l3__col").first().find(".eq-accordion-l3__block .eq-accordion-l3__answer").addClass('is-open-detail').slideDown(350);

            currentBox.find('.eq-accordion-l3__question').on('click', function() {
                let accordionBlock = $(this).closest('.eq-accordion-l3__block');
                let accordionAnswer = accordionBlock.find('.eq-accordion-l3__answer');

                if (!accordionBlock.hasClass('is-active-accordion')) {
                    accordionBlock.addClass('is-active-accordion');
                    accordionAnswer.addClass('is-open-detail').slideDown(350);
                } else {
                    accordionBlock.removeClass('is-active-accordion');
                    accordionAnswer.removeClass('is-open-detail').slideUp(350);
                }
            });
        });
    }

    let cbdBestSellerSlider = $('.js-cbd-best-sellers-slider');

    let cbdBestSellerSlidesToShowDesk = cbdBestSellerSlider.attr('data-desktop') && cbdBestSellerSlider.attr('data-desktop') !== "" && cbdBestSellerSlider.attr('data-desktop') !== undefined && cbdBestSellerSlider.attr('data-desktop') !== null ?
    parseInt(cbdBestSellerSlider.attr('data-desktop')) : 4;

    let cbdBestSellerSlidesToShowTab = cbdBestSellerSlider.attr('data-tablet') && cbdBestSellerSlider.attr('data-tablet') !== "" && cbdBestSellerSlider.attr('data-tablet') !== undefined && cbdBestSellerSlider.attr('data-tablet') !== null ?
    parseInt(cbdBestSellerSlider.attr('data-tablet')) : 3;

    let cbdBestSellerSlidesToShowMob = cbdBestSellerSlider.attr('data-mobile') && cbdBestSellerSlider.attr('data-mobile') !== "" && cbdBestSellerSlider.attr('data-mobile') !== undefined && cbdBestSellerSlider.attr('data-mobile') !== null ?
    parseInt(cbdBestSellerSlider.attr('data-mobile')) : 1;
    
    if(cbdBestSellerSlider.length > 0 && cbdBestSellerSlider.find('.eq-cbd-best-sellers__box').length > 0){
        cbdBestSellerSlider.slick({
            slidesToShow: cbdBestSellerSlidesToShowDesk,
            slidesToScroll: 1,
            arrows: false,
            dots: false,        
            loop: false,
            infinite: false,
            autoplay: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: cbdBestSellerSlidesToShowTab,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: cbdBestSellerSlidesToShowMob,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    let popularCategoriesSlider = $('.js-popular-categories-slider');

    let popularCategoriesSlidesToShowDesk = popularCategoriesSlider.attr('data-desktop') && popularCategoriesSlider.attr('data-desktop') !== "" && popularCategoriesSlider.attr('data-desktop') !== undefined && popularCategoriesSlider.attr('data-desktop') !== null ?
    parseInt(popularCategoriesSlider.attr('data-desktop')) : 2;

    let popularCategoriesSlidesToShowTab = popularCategoriesSlider.attr('data-tablet') && popularCategoriesSlider.attr('data-tablet') !== "" && popularCategoriesSlider.attr('data-tablet') !== undefined && popularCategoriesSlider.attr('data-tablet') !== null ?
    parseInt(popularCategoriesSlider.attr('data-tablet')) : 2;

    let popularCategoriesSlidesToShowMob = popularCategoriesSlider.attr('data-mobile') && popularCategoriesSlider.attr('data-mobile') !== "" && popularCategoriesSlider.attr('data-mobile') !== undefined && popularCategoriesSlider.attr('data-mobile') !== null ?
    parseInt(popularCategoriesSlider.attr('data-mobile')) : 1;
    
    if(popularCategoriesSlider.length > 0 && popularCategoriesSlider.find('.eq-popular-categories__item').length > 0){
        popularCategoriesSlider.slick({
            slidesToShow: popularCategoriesSlidesToShowDesk,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: false,
            variableWidth: false,
            adaptiveHeight: false,
            autoplay: false,
            autoplaySpeed: 6000,
            prevArrow: `<button type="button" aria-label="Previous" class="prev-arrow"><img src="https://joyorganics.com/cdn/shop/t/160/assets/arrow-l.png?v=173563952378923971611731911966" alt="prev arrow"></button>`,
            nextArrow: `<button type="button" aria-label="Next" class="next-arrow"><img src="https://joyorganics.com/cdn/shop/t/160/assets/arrow-r.png?v=64802038806612222901731911967" alt="next arrow"></button>`,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: popularCategoriesSlidesToShowTab,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: popularCategoriesSlidesToShowMob,
                    }
                }
            ]
        });
    }

    $(window).scroll(function() {
        let imgOnScroll = $(this).scrollTop();
        $('.js-scroll-function').css('background-position', parseInt(-imgOnScroll / 1) + 'px');
    });

    $('.js-cbd-info-btn').on('click', function() {
        $('.js-cbd-information-model').addClass('show');
        $('body').addClass('hidden-scroll');
    });
    
    $('.js-cbd-information-model .close').on('click', function() {
        $('.js-cbd-information-model').removeClass('show');
        $('body').removeClass('hidden-scroll');
    });

    $(document).on('click', function(e) {
        let container = $(".js-cbd-information-model .cbd-information-model__content, .js-cbd-info-btn");

        if (!$(container).is(e.target) && $(container).has(e.target).length === 0) 
        {
            $(".js-cbd-information-model").removeClass("show");
            $('body').removeClass('hidden-scroll');
        }
    });

    let exploreArticleSlider = $('.js-explore-article-slider');

    let exploreArticleSlidesToShowDesk = exploreArticleSlider.attr('data-desktop') && exploreArticleSlider.attr('data-desktop') !== "" && exploreArticleSlider.attr('data-desktop') !== undefined && exploreArticleSlider.attr('data-desktop') !== null ?
    parseInt(exploreArticleSlider.attr('data-desktop')) : 3;

    let exploreArticleSlidesToShowTab = exploreArticleSlider.attr('data-tablet') && exploreArticleSlider.attr('data-tablet') !== "" && exploreArticleSlider.attr('data-tablet') !== undefined && exploreArticleSlider.attr('data-tablet') !== null ?
    parseInt(exploreArticleSlider.attr('data-tablet')) : 2;

    let exploreArticleSlidesToShowMob = exploreArticleSlider.attr('data-mobile') && exploreArticleSlider.attr('data-mobile') !== "" && exploreArticleSlider.attr('data-mobile') !== undefined && exploreArticleSlider.attr('data-mobile') !== null ?
    parseInt(exploreArticleSlider.attr('data-mobile')) : 1;
    
    if(exploreArticleSlider.length > 0 && exploreArticleSlider.find('.eq-explore-article__item').length > 0){
        exploreArticleSlider.slick({
            slidesToShow: exploreArticleSlidesToShowDesk,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            centerMode: false,
            variableWidth: false,
            adaptiveHeight: false,
            autoplay: false,
            autoplaySpeed: 6000,
            prevArrow: `<button type="button" aria-label="Previous" class="prev-arrow"><img src="https://joyorganics.com/cdn/shop/t/160/assets/arrow-l.png?v=173563952378923971611731911966" alt="prev arrow"></button>`,
            nextArrow: `<button type="button" aria-label="Next" class="next-arrow"><img src="https://joyorganics.com/cdn/shop/t/160/assets/arrow-r.png?v=64802038806612222901731911967" alt="next arrow"></button>`,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: exploreArticleSlidesToShowTab,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: exploreArticleSlidesToShowMob,
                    }
                }
            ]
        });
    }

    let videoExpertiseLayout1 = $('.js-videos-expertise-l1');

    let videoExpertiseSlidesToShowDesk = videoExpertiseLayout1.attr('data-desktop') && videoExpertiseLayout1.attr('data-desktop') !== "" && videoExpertiseLayout1.attr('data-desktop') !== undefined && videoExpertiseLayout1.attr('data-desktop') !== null ?
    parseInt(videoExpertiseLayout1.attr('data-desktop')) : 5;
    
    let videoExpertiseSlidesToShowTab = videoExpertiseLayout1.attr('data-tablet') && videoExpertiseLayout1.attr('data-tablet') !== "" && videoExpertiseLayout1.attr('data-tablet') !== undefined && videoExpertiseLayout1.attr('data-tablet') !== null ?
    parseInt(videoExpertiseLayout1.attr('data-tablet')) : 3;

    let videoExpertiseSlidesToShowMob = videoExpertiseLayout1.attr('data-mobile') && videoExpertiseLayout1.attr('data-mobile') !== "" && videoExpertiseLayout1.attr('data-mobile') !== undefined && videoExpertiseLayout1.attr('data-mobile') !== null ?
    parseInt(videoExpertiseLayout1.attr('data-mobile')) : 1;

    if(videoExpertiseLayout1.length > 0 && videoExpertiseLayout1.find('.eq-videos-expertise-l1__item').length > 0 ){
        videoExpertiseLayout1.slick({
            slidesToShow: videoExpertiseSlidesToShowDesk,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            centerMode: false,
            variableWidth: false,
            adaptiveHeight: true,
            autoplay: false,
            autoplaySpeed: 6000,
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        centerMode: true,
                        slidesToShow: videoExpertiseSlidesToShowDesk - 1,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        centerMode: true,
                        slidesToShow: videoExpertiseSlidesToShowTab,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        centerMode: false,
                        slidesToShow: videoExpertiseSlidesToShowMob,
                    }
                }
            ]
        });
    }

    let sliderUspHeader = $(".js-softgel-header-usp");

    if(sliderUspHeader.length > 0 && sliderUspHeader.find('.eq-softgel-header__usp-slider-col').length > 0){
        let sliderUspHeaderOption = {
            speed: 5000,
            autoplay: true,
            autoplaySpeed: 0,
            centerMode: false,
            cssEase: "linear",
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            initialSlide: 1,
            arrows: false,
            mobileFirst: !0,
            responsive: [{ breakpoint: 992, settings: "unslick" }],
        };
        let winSliderUspHeader = $(window);
        winSliderUspHeader.on("load resize", function () {
            winSliderUspHeader.width() < 992 ? sliderUspHeader.not(".slick-initialized").slick(sliderUspHeaderOption) : sliderUspHeader.hasClass("slick-initialized") && sliderUspHeader.slick("unslick");
        });
    }

    
    if($('.eq-quiz-result__wrap .box .box__text .box__text-title').length > 0){
        $('.eq-quiz-result__wrap .box .box__text .box__text-title').matchHeight({
            byRow: true,
        });
    }
    if($('.eq-lab__heading').length > 0){
        $('.eq-lab__heading').matchHeight({
            byRow: true,
        });
    }
    if($('.eq-lab__desc .eq-button').length > 0){
        $('.eq-lab__desc .eq-button').matchHeight({
            byRow: true,
        });
    }

    if ($('.eq-advertorial-accordion__question').length > 0) {
        $('.eq-advertorial-accordion__box').each(function() {
            let currentBox = $(this);

            currentBox.find('.eq-advertorial-accordion__question').on('click', function() {
                let accordionBlock = $(this).closest('.eq-advertorial-accordion__block');
                let accordionAnswer = accordionBlock.find('.eq-advertorial-accordion__answer');

                if (!accordionBlock.hasClass('is-active-accordion')) {
                    accordionBlock.addClass('is-active-accordion');
                    accordionAnswer.addClass('is-open-detail').slideDown(350);
                } else {
                    accordionBlock.removeClass('is-active-accordion');
                    accordionAnswer.removeClass('is-open-detail').slideUp(350);
                }
            });
        });
    }

    let heroSlider = $('.js-banner-slider');

    if(heroSlider.length > 0){
        heroSlider.each(function() {
            $(this).slick({
                dots: true,
                infinite: true,
                speed: 800,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                autoplaySpeed: 5000,
                arrows: false,
                responsive: [{
                    breakpoint: 992,
                    settings: {
                        autoplaySpeed: 5000,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        autoplaySpeed: 5000,
                    }
                }]
            });
        });  
    }

    $('.eq-virtual-partnership iframe, .eq-page-list__desc iframe').each(function() {
        let iframeSrcGet = $(this).attr('src');
        if (iframeSrcGet && (iframeSrcGet.includes('youtube.com') || iframeSrcGet.includes('vimeo.com'))) {
            $(this).wrap('<div class="lazyframe lazyframe--embedded-video lazyframe--loaded"></div>');
        }
    });

    function switchTab(tabId) {
        $('.eq-videos-expertise-l2__tab li').removeClass('is-tab-active');
        $('.eq-videos-expertise-l2__list').removeClass('is-tab-active').hide();
        
        const selectedTab = $(`.eq-videos-expertise-l2__tab li[data-id="${tabId}"]`);
        const selectedContent = $(`#${tabId}`);
        
        selectedTab.addClass('is-tab-active');
        selectedContent.addClass('is-tab-active').show();
    }
    
    if(($('.eq-videos-expertise-l2__tab li').length > 0 && $('.eq-videos-expertise-l2__list').length > 0) && ($('.eq-videos-expertise-l2__tab li').length > 0 == $('.eq-videos-expertise-l2__list').length > 0)) {
        switchTab($('.eq-videos-expertise-l2__tab li').first().data('id'));
    }

    $('.eq-videos-expertise-l2__tab li').on('click', function() {
        const tabId = $(this).data('id');
        switchTab(tabId);
    });


    let salesProductSlider = $('.js-sales-product');
    if(salesProductSlider.length > 0 && salesProductSlider.find('.eq-sales-product__item').length > 0 ){
        salesProductSlider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: false,
            variableWidth: false,
            prevArrow: '<button type="button" aria-label="Previous" class="prev-arrow slick-prev"><img src="//joyorganics.com/cdn/shop/files/lpg-sliderArrow.png?v=16790249251990827964" alt="Slider Arrow"></button>',
            nextArrow: '<button type="button" aria-label="Next" class="next-arrow slick-next"><img src="//joyorganics.com/cdn/shop/files/lpg-sliderArrow.png?v=16790249251990827964" alt="Slider Arrow"></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    let testimonialSliderSales = $('.js-testimonials-sales-slider');

    if(testimonialSliderSales.length > 0 && testimonialSliderSales.find('.eq-testimonials-sales__slide').length > 0 ){
        testimonialSliderSales.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: false,
            variableWidth: false,
            adaptiveHeight: true,
            autoplay: false,
            autoplaySpeed: 6000,
            prevArrow: '<button type="button" aria-label="Previous" class="prev-arrow"><img src="//joyorganics.com/cdn/shop/files/lpg-sliderArrow2.png?v=13426386756341579816" alt="Slider Arrow"></button>',
            nextArrow: '<button type="button" aria-label="Next" class="next-arrow"><img src="//joyorganics.com/cdn/shop/files/lpg-sliderArrow2.png?v=13426386756341579816" alt="Slider Arrow"></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2, 
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    }

    var youtubePlayers = [];

    let videoThumbnail;
    let videoThumbnailNav;
    let videoThumbnailThumb;

    $('.eq-video-thumbnail').each(function() {
        videoThumbnail = $(this);

        videoThumbnailNav = videoThumbnail.find('.js-video-thumbnail-nav .eq-video-thumbnail__slide');
        videoThumbnailThumb = videoThumbnail.find('.js-video-thumbnail-thumb .eq-video-thumbnail__slide');
    
        if (videoThumbnailNav.length > 0 && videoThumbnailThumb.length > 0 && videoThumbnailNav.length === videoThumbnailThumb.length) {
            // Initialize main slider (js-video-thumbnail-nav) for this specific container
            videoThumbnail.find('.js-video-thumbnail-nav').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                arrows: false,
                fade: true,
                asNavFor: videoThumbnail.find('.js-video-thumbnail-thumb'),
                dots: false,
                swipe: true,
                touchThreshold: 10,
                draggable: true,
                swipeToSlide: true,
            });

            // Initialize thumbnail slider (js-video-thumbnail-thumb) for this specific container
            videoThumbnail.find('.js-video-thumbnail-thumb').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplay: false,
                arrows: true,
                asNavFor: videoThumbnail.find('.js-video-thumbnail-nav'),
                dots: false,
                focusOnSelect: true,
                prevArrow: '<button type="button" aria-label="Previous" class="prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="4" stroke="currentColor" class="size-6"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5"></path></svg></button>',
                nextArrow: '<button type="button" aria-label="Next" class="next-arrow"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="4" stroke="currentColor" class="size-6"><path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5"></path></svg></button>',
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });
        } else {
            console.log("Slider item counts do not match for a specific instance.");
        }
    });

    $('.js-video-thumbnail-nav').on('beforeChange', function(event, slick, currentSlide, nextSlide) { 
        pauseVideo(currentSlide);
    });

    function pauseVideo(slideIndex) {
        console.log("pauseVideo slideIndex : ", slideIndex);

        var iframe = $('.js-video-thumbnail-nav').find('.eq-video-thumbnail__slide').eq(slideIndex).find('iframe');
        console.log("pauseVideo iframe : ", iframe);
        var player;

        if (iframe.length > 0) {
            var videoId = iframe.attr('src').split('/')[4].split('?')[0];
            console.log("pauseVideo videoId : ", videoId);
            if (!youtubePlayers[videoId]) {
                youtubePlayers[videoId] = new YT.Player(iframe[0], {
                    events: {
                        'onReady': function(event) {
                            player = event.target;
                            console.log("events player : ", player);
                        }
                    }
                });
            } else {
                player = youtubePlayers[videoId];
                console.log("player : ", player);
            }

            if (player && player.pauseVideo) {
                player.pauseVideo();
                player.stopVideo();
            }
        }
    }
    

    if ($('.eq-accordion-sales__question').length > 0) {
      
        $(".eq-accordion-sales__col:first-child .eq-accordion-sales__block").addClass('is-active-accordion');
        $(".eq-accordion-sales__col:first-child .eq-accordion-sales__answer").addClass('is-open-detail').show();


        $('.eq-accordion-sales__box').each(function(index) {
            let currentBox = $(this);

            currentBox.find('.eq-accordion-sales__question').on('click', function() {
                let accordionBlock = $(this).closest('.eq-accordion-sales__block');
                let accordionAnswer = accordionBlock.find('.eq-accordion-sales__answer');

                $('.eq-accordion-sales__block').not(accordionBlock).removeClass('is-active-accordion');
                $('.eq-accordion-sales__answer').not(accordionAnswer).removeClass('is-open-detail').slideUp(350);

                if (!accordionBlock.hasClass('is-active-accordion')) {
                    accordionBlock.addClass('is-active-accordion');
                    accordionAnswer.addClass('is-open-detail').slideDown(350);
                } else {
                    accordionBlock.removeClass('is-active-accordion');
                    accordionAnswer.removeClass('is-open-detail').slideUp(350);
                }
            });
        });
    }

    $('.eq-softgel-header .eq-header__nav-link').click(function() {
        $('.eq-header__btn-menuclose').trigger('click');
    });

    if ($('.eq-quiz-result-tab-details .eq-quiz-result-tab-details__wrap .description .metafield-rich_text_field').length > 0) {
        $('.eq-quiz-result-tab-details .eq-quiz-result-tab-details__wrap .description .metafield-rich_text_field').Cuttr({
            truncate: 'words',
            length: 30,
            readMore: true,
            readMoreText: 'See More',
            readLessText: 'See Less',
            readMoreBtnPosition: 'inside',
            ending: '...'
        }); 
    }

});

 
function handleStickyElements() {
    let eqAnnouncementBar = $('.eq-announcement-bar');
    let eqHeader = $('.eq-header');
    console.log(eqAnnouncementBar, eqHeader);

    if ($(eqAnnouncementBar).hasClass('eq-sticky-announcement-bar') && $(eqHeader).hasClass('eq-sticky-header')) {
        let announcementBarHeight = eqAnnouncementBar.outerHeight();
        console.log("Announcement Bar Height: ", announcementBarHeight);

        if(eqHeader.parent().hasClass('shopify-section')){
            eqHeader.parent().css({
                'top': `${announcementBarHeight}px`,
            });
        }
    } else {
        if(eqHeader.parent().hasClass('shopify-section')){
            eqHeader.parent().css({
                'top': '0px',
            });
        }
    }
}

$(window).on('load', function() {
    handleStickyElements();
});

$(window).resize(function() {
    handleStickyElements();
});


/*if ($('.js-cbd-best-sellers-slider').length > 0) {
    $('.js-cbd-best-sellers-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        dots: false,        
        loop: false,
        infinite: false,
        autoplay: false,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1.7,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
}*/


